<div class="row for_mobile">
  <div i18n="@@Notes" class="col-sm-2 GeneralLabel2"><span class="align-middle"><strong>Notes</strong></span></div>
  <div class="col-sm-7"><span>{{ Day.notes }}</span></div>

  <div class="col-sm-3">
    <div style="float:right">
      <app-meal-metrics-graph [MealCals]="MealCals" [MealProtein]="MealProtein" [MealCarbs]="MealCarbs"
        [MealNetCarbs]="MealNetCarbs" [MealFats]="MealFats" [GraphInBack]="true" [ChartWidth]="'70px'"
        [ChartHeight]="'70px'">
      </app-meal-metrics-graph>
    </div>
  </div>
</div>




<div *ngFor="let meal of Day.meals; let i = index">
  <div class="remove-meal-wrapper">
    <div class="remove-meal-action">
      <button
      nbButton
      class="btn-remove-meal"
      alt="Copy"
      (click)="Copy(meal)"
      style="padding: 0px !important"
    >
      <nb-icon icon="copy-outline" alt="Copy"></nb-icon>
    </button>
    </div>
  </div>

  <mobile-meal-presentation #MealPresentation [PlanMeal]="meal" [Index]="i"> </mobile-meal-presentation>
</div>